// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS AddressCardText INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import classNames from 'classnames';

/**
 * @visibleName AddressCardText DEPRECATED
*/

export default function AddressCardText(props) {
  var location = props.location,
    serviceAreaText = props.serviceAreaText,
    className = props.className,
    iconColor = props.iconColor;
  var icon = serviceAreaText ? 'IconRadar' : 'IconMapMarkV2';
  var title = serviceAreaText || location.displayName;
  var text = serviceAreaText || "".concat(location.displayName, " (").concat(location.distance, ")");
  return /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'address-card-text': true,
      'detail-card-text': true
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "detail-card-text__location"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "detail-card-text__icon mr-half",
    color: iconColor,
    icon: icon
  }), /*#__PURE__*/React.createElement("p", {
    title: title
  }, text)));
}
AddressCardText.propTypes = {
  /** className */
  className: PropTypes.string,
  /** location object via displayName and distance */
  location: PropTypes.object,
  /** icon color */
  iconColor: PropTypes.string,
  /** text describing the service area */
  serviceAreaText: PropTypes.string
};
AddressCardText.defaultProps = {
  location: {},
  className: '',
  iconColor: '#67859E',
  serviceAreaText: null
};